import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../../../App.css";
import "../../../index.css";
import {
  Box,
  Button,
  Paper,
  IconButton,
  TextField,
  Typography,
  Tooltip,
} from "@mui/material";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import Modal from "react-modal";
import AddIcon from "@mui/icons-material/Add";
import LoadScreen from "../../Loader";
import Navbar from "../../Navbar";
import config from "../../../config";
//import CardPadrao from "../CardPadrao/CardPadrao";
import CardListPadrao from "../CardListPadrao/CardListPadrao";
import "./board_padrao.css";
import getCookie from "../../../hooks/getCookie";
import Avatar from "@mui/material/Avatar";
import { getAvatarUrl } from "../../../utils/getAvatarUrl";
import MenuLateralPadrao from "../MenuPadrao/MenuLateralPadrao";
import CardModalPadrao from "../CardModalPadrao/CardModalPadrao";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useTour } from "../../Tour/context";

Modal.setAppElement("#root"); // Necessário para acessibilidade

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}

export default function BoardPadrao() {
  const backendIp = config.backend_ip;
  const sessionId = getCookie("session_id");
  const nameComplete = getCookie("nome_completo");
  const storedUserId = getCookie("userId");
  const username = getCookie("username");
  const boardId = "board_padrao";
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [cardDetails, setCardDetails] = useState({
    title: "",
    description: "",
    comments: [],
    labels: [],
    tasks: [],
  });
  const [showArchiveList, setShowArchiveList] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [loading, setLoading] = useState(false);
  const [newTitle, setNewTitle] = useState("");
  const [selectedListId, setSelectedListId] = useState(null);
  const [selectedListName, setSelectedListName] = useState(null);
  const { registerTourAction } = useTour();

  // const navigate = useNavigate();

  const [collapsedLists, setCollapsedLists] = useState(new Set());
  const [boardBackgroundColor, setBoardBackgroundColor] = useState(null);
  const [isDarkMode, setIsDarkMode] = useState(
    document.body.classList.contains("dark")
  );
  const [showArquivados, setShowArquivados] = useState(false);

  const handleArquivadosClick = () => {
    setShowArquivados((prev) => !prev); // inverte o valor atual
  };

  useEffect(() => {
    // Atualiza cor de fundo e modo escuro/claro
    const applyBackgroundColor = () => {
      const htmlElement = document.documentElement;
      const dark = document.body.classList.contains("dark");
      setIsDarkMode(dark); // Atualiza estado imediatamente

      if (boardBackgroundColor) {
        htmlElement.style.background = boardBackgroundColor;
      } else {
        htmlElement.style.background = dark ? "#1e1e1e" : "#f2f2f2";
      }
    };

    applyBackgroundColor();

    const observer = new MutationObserver(() => {
      applyBackgroundColor();
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => {
      observer.disconnect();
    };
  }, [boardBackgroundColor]);

  useEffect(() => {
    registerTourAction("openModal", openModal);
    registerTourAction("closeModal", closeModal);
  }, [registerTourAction]);

  const openModal = () => {
    // Busca o nome da lista do card
    let listName = "";
    console.log("aqui otario de novo");
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);

    // navigate(`/board/tutorial`);
  };

  const handleCloseModal = () => {
    window.location.reload();
  };

  const handleToggleArchive = () => {
    setShowArchiveList(!showArchiveList);
  };

  const handlePopoverOpen = (event, list_id, list_name) => {
    setAnchorEl(event.currentTarget);
    setSelectedListId(list_id);
    setSelectedListName(list_name);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleTitleChangeList = (event) => {
    setNewTitle(event.target.value);
  };

  const toggleListCollapse = (listId) => {
    setCollapsedLists((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(listId)) {
        newSet.delete(listId);
      } else {
        newSet.add(listId);
      }
      return newSet;
    });
  };

  return (
    <ErrorBoundary>
      <Navbar closeModal={handleCloseModal} />
      <Box
        className="container-fundo"
        sx={{
          minWidth: "100%",
          width: "fit-content",
          maxHeight: "95vh",
          padding: "70px 0px 0px 0px",
        }}
      >
        <>
          <div style={{ display: "flex", marginTop: "70px" }}>
            {/* Menu lateral */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "40px",
              }}
            >
              <MenuLateralPadrao abrirArquivado={handleArquivadosClick} />
            </div>

            {/* Header e busca */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                height: "80px",
              }}
            >
              <div
                className="titulo-board-tutorial"
                style={{
                  display: "flex",
                  gap: "20px",
                  position: "absolute",
                  top: "90px",
                  left: "20px",
                  zIndex: 1000,
                  padding: "10px 20px 20px 20px",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    color: boardBackgroundColor
                      ? "rgba(255,255,255,0.95)"
                      : "inherit",
                    textShadow: boardBackgroundColor
                      ? "1px 1px 2px rgba(0,0,0,0.25)"
                      : "none",
                    transition: "color 0.2s",
                  }}
                >
                  Board de Tutorial
                </Typography>
              </div>
              <div
                style={{
                  position: "fixed",
                  top: "80px",
                  right: "20px",
                  zIndex: 1000,
                  padding: "10px 20px 20px 20px",
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                  background: "transparent",
                }}
                className="membros-busca"
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: "bold",
                      mr: 1,
                      color: boardBackgroundColor
                        ? "rgba(255,255,255,0.95)"
                        : "inherit",
                      textShadow: boardBackgroundColor
                        ? "1px 1px 2px rgba(0,0,0,0.25)"
                        : "none",
                      transition: "color 0.2s",
                    }}
                  >
                    Membros ativos agora:
                  </Typography>
                  <Avatar
                    src={getAvatarUrl("lesteboard")}
                    sx={{ width: 24, height: 24, ml: -1 }}
                    title="Lesteboard"
                  />
                </div>
                <Paper component="form" className="search-bar">
                  <InputBase
                    sx={{ ml: 1, flex: 1 }}
                    placeholder="Aqui você pode buscar cartões"
                    inputProps={{
                      "aria-label": "Aqui você pode buscar cartões",
                    }}
                    className="search-input"
                  />
                  <IconButton
                    type="button"
                    sx={{ p: "10px" }}
                    aria-label="search"
                  >
                    <SearchIcon className="search-icon" />
                  </IconButton>
                </Paper>
                {/* Filtro por etiquetas */}
                <div style={{ position: "relative" }}>
                  <IconButton
                    sx={{
                      p: "10px",
                      color: boardBackgroundColor
                        ? "rgba(255,255,255,0.95)"
                        : "inherit",
                      "&:hover": {
                        bgcolor: "rgba(0, 147, 115, 0.2)",
                      },
                    }}
                    title="Filtrar por etiquetas"
                  >
                    <FilterListIcon />
                  </IconButton>
                </div>
              </div>
            </div>

            {/* Conteúdo principal */}
            <div className="cor-container-fundo">
              <Box
                className="box-container"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  padding: "20px 20px 20px 0px",
                  minHeight: "400px",
                }}
              >
                <CardListPadrao
                  isDarkMode={isDarkMode}
                  showArquivados={showArquivados}
                  openModal={openModal}
                />

                <div className="column-add" style={{ width: "250px" }}>
                  <Button
                    className="button-add-list lista"
                    startIcon={<AddIcon />}
                    style={{
                      backgroundColor: "var(--button-bg-color, #f0f0f0)",
                      color: boardBackgroundColor
                        ? "rgba(173, 169, 169, 0.95)"
                        : "var(--button-text-color, #575757)",
                      textShadow: boardBackgroundColor
                        ? "1px 1px 2px rgba(117, 108, 108, 0.25)"
                        : "none",
                      borderRadius: "5px",
                      padding: "5px 15px",
                      fontWeight: "bold",
                      marginLeft: "7px",
                      transition: "background-color 0.3s, color 0.3s",
                      cursor: "pointer",
                    }}
                  >
                    Adicionar lista
                  </Button>
                </div>
              </Box>
            </div>
          </div>
          {modalIsOpen && (
            <CardModalPadrao
              modalIsOpen={modalIsOpen}
              closeModal={closeModal}
            />
          )}
        </>
      </Box>
    </ErrorBoundary>
  );
}
